export default [
  { value: 'current_day', text: 'Current Day', hint: '', compared_period: '' },
  { value: 'yesterday', text: 'Yesterday', hint: '', compared_period: '' },
  { value: 'this_week', text: 'This Week', hint: '', compared_period: '' },
  { value: 'last_7_days', text: 'Last 7 days', hint: '', compared_period: '' },
  { value: 'last_week', text: 'Last Week', hint: '', compared_period: '' },
  { value: 'last_14_days', text: 'Last 14 days', hint: '', compared_period: '' },
  { value: 'this_month', text: 'This Month', hint: '', compared_period: '' },
  { value: 'last_30_days', text: 'Last 30 days', hint: '', compared_period: '' },
  { value: 'last_month', text: 'Last Month', hint: '', compared_period: '' },
  { value: 'last_90_days', text: 'Last 90 days', hint: '', compared_period: '' },
  { value: 'this_year', text: 'This Year', hint: '', compared_period: '' },
  { value: 'last_year', text: 'Last Year', hint: '', compared_period: '' },
  { value: 'all_time', text: 'All Time', hint: '', compared_period: '' },
];
